import { t } from "@/i18n-js/instance";
import { ConfirmationCardLayout } from "./ConfirmationCardLayout";

export interface ProfileFieldConfirmationCardProps {
  field_type?: string;
  label?: string;
}

export const ProfileFieldConfirmationCard = ({
  label,
  field_type,
}: ProfileFieldConfirmationCardProps) => (
  <ConfirmationCardLayout
    title={t("help_widget.copilot.confirmation_card.title_profile_field")}
    attributes={[
      {
        label: t("help_widget.copilot.confirmation_card.name"),
        value: label,
      },
      {
        label: t("help_widget.copilot.confirmation_card.field_type"),
        value: field_type,
      },
    ]}
  />
);
